import { apiAuth, apiAuthPublic, apiPublic } from "./clients";

let refreshPromise = null;

async function refreshToken() {
  if (!refreshPromise) {
    refreshPromise = apiAuthPublic
      .post("login/refresh/")
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

apiAuthPublic.interceptors.response.use(
  response => response,
  async error => {
    const status = error.response?.status;
    if (status >= 500) {
      window.dispatchEvent(new Event("serverError"));
    }
    if (status === 429) {
      window.dispatchEvent(new Event("rateLimitError"));
    }
    if (!status) {
      console.error("Network error:", error);
      window.dispatchEvent(new Event("networkError"));
    }
    return Promise.reject(error);
  }
);

apiPublic.interceptors.response.use(
  response => response,
  async error => {
    const status = error.response?.status;
    if (status >= 500) {
      window.dispatchEvent(new Event("serverError"));
    }
    if (status === 429) {
      window.dispatchEvent(new Event("rateLimitError"));
    }
    if (!status) {
      console.error("Network error:", error);
      window.dispatchEvent(new Event("networkError"));
    }
    return Promise.reject(error);
  }
);


apiAuth.interceptors.response.use(
  response => response,
  async error => {
    const original = error.config;
    const status = error.response?.status;
    if (
      error.response?.status === 401 &&
      !original._retry
    ) {
      original._retry = true;

      try {
        await refreshToken();
        return apiAuth(original);
      } catch(err) {
        window.dispatchEvent(new Event("unauthorized"));
        return Promise.reject(err);
      }
    }
    if (status === 401) {
      window.dispatchEvent(new Event("unauthorized"));
    }
    if (status === 429) {
      window.dispatchEvent(new Event("rateLimitError"));
    }
    if (status >= 500) {
      window.dispatchEvent(new Event("serverError"));
    }
    if (!status) {
      console.error("Network error:", error);
      window.dispatchEvent(new Event("networkError"));
    }

    return Promise.reject(error);
  }
);